/**
 * Default: Components / Shared > Player
 *
 * @copyright 2026 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import {
	SelectorEngine,
	Data,
	Manipulator,
	EventHandler
} from '@ifabnpm/bootstrap/dom.js';

import Player from '@ifabnpm/bootstrap/component/player.js';

// -------
// Private
// -------


// ------
// Public
// ------

/**
 * Player anpassen und initialisieren.
 *
 * @returns {Promise<void>}
 */
const init = async (o = {}) => {
	const containerPlayerMedia = SelectorEngine.find('.player-media');
	const bg = `<svg aria-hidden="true" class="svg-box" preserveAspectRatio="none" viewBox="0 0 330 170" xmlns="http://www.w3.org/2000/svg">
		<use xlink:href="#svg-box-2"></use>
	</svg>`;

	for (const element of containerPlayerMedia) {
		Manipulator.elementAppend(bg, element);
	}

	Player.init({
		audio: {
			volume: 0.5
		},
		video: {
			volume: 0.5
		}
	});
};

// Export
export default {
	init: init
};
